import { useState, useEffect } from "react";
import { FileText } from "lucide-react";
import api from "@/lib/api";
import DashboardShell from "@/components/layout/DashboardShell";
import { agencyMenu } from "@/config/menus";
import { PageHeader } from "@/components/KpiCard";
import { StatusPill, inr, LoadingScreen, EmptyState } from "@/components/common";

export default function AgencyQuotes() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/quotes/mine").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  return (
    <DashboardShell menu={agencyMenu} title="My Quotations">
      <PageHeader title="Submitted Quotations" subtitle="Track the status of all quotations you've submitted." />
      {!rows ? <LoadingScreen /> : rows.length === 0 ? (
        <EmptyState icon={FileText} title="No quotations submitted" hint="Respond to leads to submit your first quotation." />
      ) : (
        <div className="bg-white border border-navy-200 rounded-xl overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]">
            <thead className="bg-navy-50 text-navy-500 text-xs uppercase"><tr><th className="text-left p-3">Price/guard</th><th className="p-3">Total/month</th><th className="p-3">SLA</th><th className="p-3">Supervisor</th><th className="p-3">Submitted</th><th className="p-3">Status</th></tr></thead>
            <tbody>
              {rows.map((q) => (
                <tr key={q.id} className="border-t border-navy-100" data-testid={`myquote-${q.id}`}>
                  <td className="p-3 font-semibold text-navy-900">{inr(q.price_per_guard_month)}</td>
                  <td className="p-3 text-center font-bold text-navy-900">{inr(q.total_monthly)}</td>
                  <td className="p-3 text-center text-navy-600">{q.replacement_sla_hours}h</td>
                  <td className="p-3 text-center text-navy-600">{q.supervisor_included ? "Yes" : "No"}</td>
                  <td className="p-3 text-center text-navy-500 text-xs">{q.created_at?.slice(0, 10)}</td>
                  <td className="p-3 text-center"><StatusPill status={q.status} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </DashboardShell>
  );
}
